/** Use the authorized job, never copy draft keys or arbitrary query values into an application. */
export function salonjobsApplicationPageUrl(pageUrl: string, salonId: string, jobId: string): string {
  const url = new URL(`/salons/${encodeURIComponent(salonId)}`, new URL(pageUrl).origin);
  url.searchParams.set("job_id", jobId);
  return url.href;
}
